module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 155.c6d680e5.png";